import { combineReducers } from 'redux'
import contactDetails from './contactDetails'
import contacts from './contacts'
import credentials from './credentials'
import customAttributes from './customAttributes'
import groupDetails from './groupDetails'
import groups from './groups'
import scheduledEmailsByID from './scheduledEmailsByID'
import session from './session'
import tasks from './tasks'
import taskTypes from './taskTypes'
import templatesById from './templatesById'
import forms from './forms'
import onboarding from './onboarding'
import schemas from './schemas'
import eventgoaloptions from './eventgoaloptions'
import campaigns from './campaigns'
import phonenumbers from './phonenumbers'
import inbox from './inbox'
import invites from './invites'
import users from './users'
import urls from './urls'
import inboxfilter from './inboxfilter'
import inboxuserfilter from './inboxuserfilter.js'
import knowledge from './knowledge'
import a2p10dlc from './a2p10dlc'

export default combineReducers({
  a2p10dlc,
  campaigns,
  contactDetails,
  contacts,
  credentials,
  customAttributes,
  eventgoaloptions,
  forms,
  knowledge,
  groupDetails,
  groups,
  session,
  scheduledEmailsByID,
  tasks,
  taskTypes,
  templatesById,
  onboarding,
  schemas,
  phonenumbers,
  inbox,
  invites,
  users,
  urls,
  inboxfilter,
  inboxuserfilter,
})
